import { useDispatch, useSelector } from "react-redux";
import { setAdminChecking, setAllData, setConfigData, setConfigUpdateButtonLoading, setMeetWithDietitianData, setOnboardingData, setOnboardingUpdateButtonLoading, setSelectedSettingsPage, setTermsAndConditionsData } from "../../Store/slices/settingsSlice";
import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";
import { getAuth } from "firebase/auth";
import { useNavigationHook } from "../useNavigationHook";
import { setAccessToken } from "../../Store/slices/authSlice";
import { storage } from "../../firebaseConfig";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { RootState } from "../../Store/store";

export const useSettingsHook = () => {
    const dispatch = useDispatch();
    const ROUTES = {
        GET_ALL_DATA: 'https://getonboardingdatav2-e2pvzfzrwq-uc.a.run.app',
        GET_CONFIGS: 'https://us-central1-eatwellmamav2.cloudfunctions.net/getConfigs',
        UPDATE_CONFIGS: 'https://us-central1-eatwellmamav2.cloudfunctions.net/updateConfigs',
        GET_ONBOARDING_DATA: 'https://getonboardingdatav2-e2pvzfzrwq-uc.a.run.app',
    }

    const {
        selectedSettingsPage,
        configData,
        configUpdateButtonLoading,
        onboardingData,
        onboardingUpdateButtonLoading,
    } = useSelector((state: RootState) => state.settings.value);

    const {
        navigateTo
    } = useNavigationHook();

    const changeSelectedSettingsPage = (page: number) => {
        dispatch(setSelectedSettingsPage(page));
    };

    const { accessToken } = useSelector((state: any) => state.auth.value);

    const getAllData = async () => {
        await axios.get(
            ROUTES.GET_ALL_DATA
        ).then((response) => {
            console.log("Get All Data Response:", response.data);
            dispatch(setAllData(response.data.data));
            dispatch(setConfigData(response.data.data.Configs));
            dispatch(setMeetWithDietitianData(response.data.data.MeetWithDietitian));
            dispatch(setOnboardingData(response.data.data.OnboardingFlow));
            dispatch(setTermsAndConditionsData(response.data.data.TermsAndConditions));
        })
            .catch((error) => {
                console.log("Get All Data Error:", error);
                console.log("Get All Data Error Message:", error.response.data);
                toast.error("Error fetching all data");
            });
    };

    const checkIfUserIsAdmin = async () => {
        dispatch(setAdminChecking(true));
        await getAuth()
            .onAuthStateChanged((user) => {
                if (user) {
                    user.getIdTokenResult()
                        .then((idTokenResult) => {
                            console.log("idTokenResult:", idTokenResult);
                            console.log("admin:", idTokenResult.claims.admin);
                            if (idTokenResult.claims.admin === true) {
                                console.log("User is admin");
                                console.log("accessToken check:", idTokenResult.token);
                                dispatch(setAdminChecking(false));
                                dispatch(setAccessToken(idTokenResult.token));
                                fetchConfigs();
                            } else {
                                console.log("User is not admin");
                                // navigate to user page
                                navigateTo("/");
                            }
                        })
                        .catch((error) => {
                            console.log("Error:", error);
                            navigateTo("/");
                        });
                } else {
                    console.log("User is not logged in");
                    navigateTo("/");
                }
            }
            );
    };

    const fetchConfigs = async () => {
        await axios.get(
            ROUTES.GET_CONFIGS
        ).then((response) => {
            console.log("Fetch Configs Response:", response.data);
            dispatch(setConfigData(response.data.data));
        }).catch((error) => {
            console.log("Fetch Configs Error:", error);
            console.log("Fetch Configs Error Message:", error.response.data);
            toast.error("Error fetching configs");
        });
    };

    const setVersionNumber = (versionNumber: string) => {
        dispatch(setConfigData({ ...configData, versionNumber }));
    };

    const setFreeQnACount = (freeQnACount: number) => {
        dispatch(setConfigData({ ...configData, freeQnACount }));
    };

    const setFreeBlogCount = (freeBlogCount: number) => {
        dispatch(setConfigData({ ...configData, freeBlogCount }));
    };

    const setFreeRecipeCount = (freeRecipeCount: number) => {
        dispatch(setConfigData({ ...configData, freeRecipeCount }));
    };

    const setWaterNotificationCount = (waterNotificationCount: number) => {
        dispatch(setConfigData({ ...configData, waterNotificationCount }));
    };

    const setAppMaintenance = (appMaintenance: boolean) => {
        dispatch(setConfigData({ ...configData, appMaintenance }));
    };

    const updateData = async () => {
        console.log("accessToken:", accessToken);
        dispatch(setConfigUpdateButtonLoading(true));
        await axios.put(
            ROUTES.UPDATE_CONFIGS,
            {
                freeBlogCount: configData.freeBlogCount,
                freeQnACount: configData.freeQnACount,
                freeRecipeCount: configData.freeRecipeCount,
                versionNumber: configData.versionNumber,
                waterNotificationCount: configData.waterNotificationCount,
                appMaintenance: configData.appMaintenance,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + accessToken,
                }
            }
        ).then((response) => {
            console.log("Update Configs Response:", response.data);
            toast.success("Configs Updated Successfully");
            fetchConfigs();
            dispatch(setConfigUpdateButtonLoading(false));
        }).catch((error) => {
            console.log("Update Configs Error:", error);
            console.log("Update Configs Error Message:", error.response.data);
            toast.error("Error updating configs");
            dispatch(setConfigUpdateButtonLoading(false));
        });
    };

    const fetchOnboardingData = async () => {
        await axios.get(
            ROUTES.GET_ONBOARDING_DATA,
        )
            .then((response) => {
                console.log("Onboarding Data:", response.data);
                dispatch(setOnboardingData(response.data.data));
            })
            .catch((error) => {
                console.log("Onboarding Data Error:", error);
                console.log("Onboarding Data Error Message:", error.response.data);
                toast.error("Error fetching onboarding data");
            });
    };

    const [file, setFile] = useState<any>(null);  // Fotoğraf dosyası
    const [uploading, setUploading] = useState<boolean>(false); // Yükleme durumu
    const [progress, setProgress] = useState<number>(0); // Yükleme ilerlemesi

    const handleFileChange = async (event: any, which_image: string) => {
        toast.loading("Image loading...");
        dispatch(setOnboardingUpdateButtonLoading(true));
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            console.log("Selected File =>", selectedFile);
            await handleUpload(selectedFile, which_image);

        }
    };

    const [onboardingLoading, setOnboardingLoading] = useState<boolean>(false);

    // Fotoğrafı Firebase'e yükleme
    const handleUpload = async (file_: any, which_image: string) => {
        console.log("File =>", file_);
        if (!file_) return;

        const storageRef = ref(storage, 'general/' + file_.name);
        const uploadTask = uploadBytesResumable(storageRef, file_);

        // Yükleme durumu takibi
        setUploading(true);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                // Yükleme ilerlemesi (isteğe bağlı)
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${progress}% done`);
                setProgress(progress);
            },
            (error) => {
                console.error('Upload error:', error);
                setUploading(false);
                dispatch(setOnboardingUpdateButtonLoading(false));
            },
            () => {
                // Yükleme tamamlandığında URL'yi al
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('File available at', downloadURL);
                    console.log("Which Image:", which_image);
                    setUploading(false);
                    if (which_image === 'flow_1_img') {
                        dispatch(setOnboardingData({ ...onboardingData, flow_1_img: downloadURL }));
                    }
                    if (which_image === 'flow_2_img') {
                        dispatch(setOnboardingData({ ...onboardingData, flow_2_img: downloadURL }));
                    }
                    if (which_image === 'flow_3_img') {
                        dispatch(setOnboardingData({ ...onboardingData, flow_3_img: downloadURL }));
                    }
                    setTimeout(() => { toast.dismiss() }, 1000);
                    toast.success("Image loaded successfully");
                    console.log("Onboarding Data:", onboardingData);
                    dispatch(setOnboardingUpdateButtonLoading(false));
                });
            }
        );

    };

    const updateOnboardingData = async () => {
        dispatch(setOnboardingUpdateButtonLoading(true));
        const URL = 'https://us-central1-eatwellmamav2.cloudfunctions.net/updateOnboardingData';
        await axios.post(
            URL,
            {
                openingTitle: onboardingData.openingTitle,
                flow_1_title: onboardingData.flow_1_title,
                flow_1_img: onboardingData.flow_1_img,
                flow_2_title: onboardingData.flow_2_title,
                flow_2_img: onboardingData.flow_2_img,
                flow_3_title: onboardingData.flow_3_title,
                flow_3_img: onboardingData.flow_3_img,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + accessToken,
                }
            }
        ).then((response) => {
            console.log("Update Onboarding Data Response:", response.data);
            toast.success("Onboarding Data Updated Successfully");
            dispatch(setOnboardingUpdateButtonLoading(false));
        }).catch((error) => {
            console.log("Update Onboarding Data Error:", error);
            console.log("Update Onboarding Data Error Message:", error.response.data);
            toast.error("Error updating onboarding data");
            dispatch(setOnboardingUpdateButtonLoading(false));
        });
    };


    return {
        selectedSettingsPage,
        changeSelectedSettingsPage,
        fetchConfigs,
        configData,
        setVersionNumber,
        setFreeQnACount,
        setFreeBlogCount,
        setFreeRecipeCount,
        setWaterNotificationCount,
        setAppMaintenance,
        updateData,
        checkIfUserIsAdmin,
        fetchOnboardingData,
        onboardingData,
        onboardingUpdateButtonLoading,
        configUpdateButtonLoading,
        handleFileChange,
        file,
        uploading,
        progress,
        updateOnboardingData,
        getAllData,
    }
};